import { DataModel } from '../../../dto/dto.js';
import { OpenAccessPassTemplate } from '../../open-access-pass/open-access-pass-template.js';
import { CustomerProfile } from '../../customer-profile.js';
import { OpenAccessPassVariation } from '../../open-access-pass/open-access-pass-variation.js';
import { ComponentList } from '../../../../components/core/component-list.js';

export abstract class LegacyPassCartItemDto extends DataModel {
  abstract get passId(): string;
  abstract get code(): string;
  abstract get scanCode(): string;
  abstract get viaProductId(): string | null;
  abstract get viaGroupId(): string | null;
  abstract get customer(): CustomerProfile | null;
  abstract get template(): OpenAccessPassTemplate;
  abstract get variation(): OpenAccessPassVariation | null;
  abstract get components(): ComponentList;
}
